import styled, { css } from 'styled-components';
import { CircularProgress } from '@mui/material';

import { ReactComponent as HeartIconOutline } from '../../../../../assets/icons/v2/heart-icon.svg';
import { ReactComponent as HeartIconFilled } from '../../../../../assets/icons/v2/heart-icon-selected.svg';
import colors from '../../../../../styles/colors';

const Container = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 5px;
  color: ${colors.shades.beta1};
  font-size: 15px;
  background-color: ${colors.shades.gamma5};
  border-radius: 20px;
  padding: 5px 10px;
  cursor: ${({ $isReadOnly }) => ($isReadOnly ? 'default' : 'pointer')};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ $isReadOnly }) => ($isReadOnly ? colors.shades.gamma5 : colors.shades.gamma8)};
  }
`;

const heartIconStyle = css`
  width: 18px;
  height: 18px;
  color: ${colors.shades.secondary3};
`;

const StyledHeartIconOutline = styled(HeartIconOutline)`
  ${heartIconStyle};
`;

const StyledHeartIconFilled = styled(HeartIconFilled)`
  ${heartIconStyle};
`;

const StyledCircularProgress = styled(CircularProgress)`
  color: ${colors.shades.secondary3};
`;

export {
  Container,
  StyledHeartIconOutline as HeartIconOutline,
  StyledHeartIconFilled as HeartIconFilled,
  StyledCircularProgress as LikeLoadingSpinner,
};
